import { useParams } from "react-router-dom";
import { ReactFunctionalComponent, IIdentifiable, ReactComponentType } from "./types/_types";
import { useIdBuilder } from "./use-id-builder.hook";
import { applyActions } from "./utils.actions";
import { useUserContext } from "../../_runtime/iam/session.context";
import { get } from "http";
import { getComponent, getProps, traverseAndModify } from "./props.helpers";
import { findFirstValueDefined, hasPropOrPath } from "../../packages/core/toolbox/objects";
import { has } from "ramda";

export const withContainer = <P extends IIdentifiable>(
  InnerComponent: ReactComponentType<any>
): ReactFunctionalComponent<any> => {

  return ({ id:componentId, ...props }: any) => {
    const id = useIdBuilder(componentId);
    const urlParams = useParams();
    const userContext = useUserContext();
    const currentContextParams = {
      ...urlParams,
      ...userContext,
    };
    const actions = findFirstValueDefined(["component.actions","actions"],props,undefined);
    if(hasPropOrPath("component.props")(props)) {
      const { props:compProps, ...rest} = props.component;
        const newProps = actions ? {
          ...props,
          component: {
            props: applyActions(compProps, actions,currentContextParams),
            ...rest
          }
        } : props;
        return (<InnerComponent {...(newProps as P)} id={id} />);

    }
    if(hasPropOrPath("props")(props)) {
      const { props:compProps, ...rest} = props;
      const newP = actions ? {
        ...props,
        component: {
          props: applyActions(compProps, actions,currentContextParams),
          ...rest
        }
      } : props;
      return (<InnerComponent {...(newP as P)} id={id} />);
    }
    return (<InnerComponent {...(props as P)} id={id} />);
  }}
